import { createSlice } from "@reduxjs/toolkit";

export const gameDataSlice = createSlice({
  name: "gameData",
  initialState: {
    currentMultiplier: 0,
    winningAmount: 0,
    numOfCells: 0,
    openedIndexes: [],
    winningCounter: 0,
    losingCounter: 0,
  },
  reducers: {
    setGameData: (state, action) => {
      state.winningAmount = action.payload.winningAmount;
      state.currentMultiplier = action.payload.currentMultiplier;

      if (action.payload.numOfCells !== undefined) {
        state.numOfCells = action.payload.numOfCells;
      }
      if (action.payload.openedIndexes !== undefined) {
        state.openedIndexes = action.payload.openedIndexes;
      }
    },
    setWinningAmount: (state, action) => {
      state.winningAmount += action.payload;
    },
    setCurrentMultiplier: (state, action) => {
      state.currentMultiplier = action.payload;
    },

    setNumOfCells: (state, action) => {
      if (action.payload !== undefined) {
        state.numOfCells = action.payload;
      }
    },
    setOpenedIndexes: (state, action) => {
      if (action.payload !== undefined) {
        state.openedIndexes = action.payload;
      }
    },
    resetOpenedIndexes: (state) => {
      state.openedIndexes = [];
    },
    addToWinningCounter: (state) => {
      state.winningCounter++;
    },
    addToLosingCounter: (state) => {
      state.losingCounter++;
    },
    resetGameData: (state) => {
      state.winningAmount = 0;
      state.currentMultiplier = 0;
      state.numOfCells = 0;
      state.openedIndexes = [];
      state.winningCounter = 0;
      state.losingCounter = 0;
    },
    resetGameDataWithoutMultiplier: (state) => {
      state.numOfCells = 0;
      state.openedIndexes = [];
    },
  },
});

export const {
  setGameData,
  resetOpenedIndexes,
  resetGameData,
  setWinningAmount,
  setCurrentMultiplier,
  setNumOfCells,
  setOpenedIndexes,
  addToCurrentMultiplier,
  resetGameDataWithoutMultiplier,
  addToWinningCounter,
  addToLosingCounter,
} = gameDataSlice.actions;

export default gameDataSlice.reducer;
